var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-pane"},[_c('div',{staticClass:"preicon"},[_c('IosDocumentOutline',{staticClass:"no-data-icon"})],1),_c('div',{staticClass:"display-text"},[_c('span',[_vm._v(_vm._s(_vm.$t("图片加载失败#!!!#src/pages/H5/Cloud/components/imagepreview/components/loaderror.vue_1")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }